
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import Message from 'primevue/message'
import functionsCatalogPreviewDialogDescriptor from './FunctionsCatalogPreviewDialogDescriptor.json'

export default defineComponent({
    name: 'functions-catalog-preview-warning-dialog',
    components: { Dialog, Message },
    props: {
        visible: { type: Boolean },
        warningTitle: { type: String },
        warningMessage: { type: String }
    },
    emits: ['close'],
    data() {
        return { functionsCatalogPreviewDialogDescriptor }
    },
    created() {},
    methods: {}
})
